import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Box, Container, Typography } from "@mui/material";
import { theme } from "./theme";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import ContentSection from "./components/ContentSection";
import Footer from "./components/Footer";

export default function LandingPage() {
  return (
    <ThemeProvider theme={theme}>
      <Box>
        {/* News Banner */}
        {/* <Box sx={{ bgcolor: 'primary.dark', color: 'white', py: 1 }}>
          <Container maxWidth="lg">
            <Typography variant="body2">
              News: We Need Your Feedback on Geospatial Documentation!
            </Typography>
          </Container>
        </Box> */}

        <Navigation />
        <Hero />
        {/*
          <ContentSection />
        <Footer />
        */}
      </Box>
    </ThemeProvider>
  );
}
